import portalCommunication from '@3plearning/mathletics-portal-communication-service';

export const SHOW_BUSY = 'SHOW_BUSY';
export const HIDE_BUSY = 'HIDE_BUSY';

function showBusy() {
    return (dispatch) => {
        portalCommunication.requestLoadingSpinner(true);
        dispatch({ type: SHOW_BUSY });
    };
}

function hideBusy() {
    return (dispatch) => {
        portalCommunication.requestLoadingSpinner(false);
        dispatch({ type: HIDE_BUSY });
    };
}

export default {
    showBusy,
    hideBusy
};



// WEBPACK FOOTER //
// ./components/busy-indicator/busy-indicator-actions.js